import React from 'react'
import { ChatMessageProps } from '../../interfaces'
import styles from './styles.module.scss'

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
    return (
        <div className={`${styles.message} ${styles[message.sender]}`}>
            <div className={styles.messageContent}>{message.content}</div>
            <div className={styles.messageTime}>{new Date(message.timestamp).toLocaleTimeString()}</div>
        </div>
    )
}

export const LoadingMessage: React.FC = () => {
    return (
        <div className={`${styles.message} ${styles.assistant}`}>
            <div className={styles.messageContent}>
                <div className={styles.loadingDots}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    )
}
